// Swap YouTube thumbnail facades for the real iframe on click, so the
// heavy player only loads for videos people actually watch
const facades = document.querySelectorAll('.yt-facade');

if (facades.length) {
  // Warm up connections to YouTube the first time someone shows intent
  let warmed = false;
  const warm = () => {
    if (warmed) return;
    warmed = true;
    ['https://www.youtube-nocookie.com', 'https://www.google.com', 'https://i.ytimg.com'].forEach(href => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      document.head.appendChild(link);
    });
  };

  // Remember each iframe's original facade so it can be restored
  const originals = new WeakMap();

  facades.forEach(facade => {
    facade.addEventListener('pointerover', warm, { once: true });
    facade.addEventListener('focus', warm, { once: true });

    facade.addEventListener('click', e => {
      e.preventDefault();
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${facade.dataset.id}?autoplay=1&rel=0`;
      iframe.title = facade.dataset.title;
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.className = 'yt-iframe';
      originals.set(iframe, facade);
      facade.replaceWith(iframe);
      iframe.focus();
    });
  });

  // Stop playback when a video's accordion (e.g. a priority) is closed.
  // 'toggle' doesn't bubble, so listen in the capture phase.
  document.addEventListener('toggle', e => {
    if (e.target.open) return;
    e.target.querySelectorAll('.yt-iframe').forEach(iframe => {
      iframe.replaceWith(originals.get(iframe));
    });
  }, true);
}
